export default __webpack_public_path__ + "static/media/Explain.a6c8fa9e.mov";